import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Container,
  Dialog,
  Grid,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import { setDefaultSelectedTemplate } from 'src/redux/reducers/templates/actions';
import { FormattedMessage } from 'react-intl';
import TemplateCard from './TemplateCard';
import { getTemplates } from '../../../redux/reducers/templates/selectors';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: 15,
    paddingTop: 15,
    margin: '20px 0 0 0'
  },
  cardsbox: {
    marginTop: '12px'
  },
  templateName: {
    margin: '0 0 10px 0',
    paddingTop: '10px',
    fontSize: '25px'
  },
  templateText: {
    textAlign: 'center',
    fontSize: '12px',
    color: '#000000'
  },
  tmpBox: {
    opacity: 0.7,
    '&:hover': {
      borderColor: '#dddee1',
      boxShadow: '1px',
      opacity: 1
    }
  },
  dialogTitle: {
    padding: '15px 0 0 20px',
    textAlign: 'center'
  },
  templateThumb: {
    margin: '0 4px 0px 4px',
    cursor: 'pointer',
    width: 47,
    height: 47,
    display: 'flex',
    border: '1px solid',
    borderColor: '#dddee1',
    backgroundColor: '#00000',
  },
  templateCategory: {
    margin: '20px 0 20px 0',
    padding: '0 0 30px 30px'
  },
  tmpAcc: {
    padding: '0 0 0 12px'
  },
  accordionDetails: {
    margin: '10px 8px 10px 8px'
  }
});

const MyAccordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(Accordion);

const MyAccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(255,255,255,1)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    borderRadius: 4,
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(AccordionSummary);

const MyAccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(AccordionDetails);

class TemplateList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      data: 'default',
      selectedTemplateId: this.props.defaultSelectedTemplateId,
    };
    this.handleActiveTemplateChange = this.handleActiveTemplateChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleClickOpen() {
    this.setState({ open: true });
  }

  getGroupedTemplates() {
    const groupedTempls = {};

    this.props.templates.forEach((templ) => {
      if (templ.group) {
        if (!groupedTempls[templ.group]) {
          groupedTempls[templ.group] = [templ];
        } else {
          groupedTempls[templ.group].push(templ);
        }
      } else if (groupedTempls.default) {
        groupedTempls.default.push(templ);
      } else {
        groupedTempls.default = [templ];
      }
    });

    return Object.keys(groupedTempls)
      .sort()
      .reduce((acc, key) => ({
        ...acc, [key]: groupedTempls[key]
      }), {});
  }

  handleActiveTemplateChange(id) {
    if (this.state.open) {
      this.setState({ open: false });
    }
    this.props.setDefaultSelectedTemplate(id);
    this.setState({
      selectedTemplateId: id,
    });
  }

  render() {
    const { classes, ...rest } = this.props;

    return (
      <Box className={classes.tmpBox} key="more">
        <Avatar
          className={classes.templateThumb}
          variant="rounded"
          src="/app/static/images/templates/more.jpg"
          square="true"
          title="Click to Activate"
          onClick={this.handleClickOpen}
        />
        {/* <SimpleDialog open="true" onClose={handleClose}> */}
        <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={this.state.open}>
          <Box>
            <Typography
              className={classes.dialogTitle}
              color="textPrimary"
              variant="h4"
            >
              <FormattedMessage id="label.counting" defaultMessage="Counting templates"/>
            </Typography>
            <Page
              className={classes.root}
              title="Products"
              {...rest}
            >
              <Container maxWidth={false}>
                <Box
                  mt={12}
                  className={classes.cardsbox}
                >
                  {Object.entries(this.getGroupedTemplates()).map(([category, value]) => (
                    <Box key={category}>
                      <MyAccordion>
                        <MyAccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <Typography className={classes.tmpAcc} variant="h4">{category}</Typography>
                        </MyAccordionSummary>
                        <MyAccordionDetails classes={{ root: classes.accordionDetails }}>
                          <Grid
                            container
                            spacing={3}
                            flex-wrap="wrap"
                            justify-content="space-evenly"
                          >
                            {value.map((template) => (
                              <Grid
                                item
                                key={template.id}
                                onClick={() => this.handleActiveTemplateChange(template.id)}
                              >
                                <TemplateCard
                                  className={classes.productCard}
                                  template={template}
                                  selected={template.id === this.state.selectedTemplateId}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </MyAccordionDetails>
                      </MyAccordion>
                      <Box p={1} />
                    </Box>
                  ))}
                </Box>
              </Container>
            </Page>
          </Box>
        </Dialog>
        {/* <SimpleDialog selectedValue={selectedValue} */}
        {/* open={open} onClose={handleClose} /> */}
        <Typography className={classes.templateText}>
          <FormattedMessage id="label.more" defaultMessage="More"/>
        </Typography>
      </Box>
    );
  }
}

TemplateList.propTypes = {
  classes: PropTypes.object.isRequired,
  setDefaultSelectedTemplate: PropTypes.func,
  templates: PropTypes.array,
  open: PropTypes.bool,
  defaultSelectedTemplateId: PropTypes.string,
};

export default connect(
  getTemplates,
  { setDefaultSelectedTemplate }
)(withStyles(styles)(TemplateList));
